export function showCountrysideRulesReducer(state: boolean = false): boolean {
  return state;
}
